module.exports = __webpack_public_path__ + "img/toplogo2.d85d0662.png";